const { registerBlockType, setAttributes } = wp.blocks;
// import apiFetch from '@wordpress/api-fetch';
const apiFetch = wp.apiFetch;

const { Component } = wp.element;
const { TabPanel } = wp.components;

/**
 * Localized data from PHP is contained in SareData global variable
 * @var SareData
 * @property SareData.sites
 * @property SareData.currentSiteUrl
 * @property SareData.nonce
 */

// Set the nonce we will use for API calls
apiFetch.use( apiFetch.createNonceMiddleware( SareData.nonce ) );

export default registerBlockType(
	"sare/network-shared",
	{
		title : "Network Shared Block",
		description : "Displays blocks that are shared on other sites.",
		category : "sare-blocks",
		icon: "chart-bar",
		keywords: [
			"network",
			"shared"
		],
		attributes: {
			siteID : {
				type: 'integer',
				default: 0
			},
			blockID : {
				type: 'integer',
				default: 0
			},
		},


		edit: class extends Component {
			constructor() {
				// get parent constructor
				super(...arguments);

				// when converted to a 'real' React component, need to do this with all functions that setAttributes() to get the correct context.
				this.updateAttributes = this.updateAttributes.bind(this);
				this.handleGetBlocksResponse = this.handleGetBlocksResponse.bind(this);

				// and we can have state that is uncoupled from 'attributes'. Attributes are saved with the block, state isn't.
				this.state = {
					siteBlocks : [],
					selectedTab : 'select',
					newRender : false
				};

				/**
				 * If this block has a siteID saved in the DB, fetch the blocks for the site so we can render the block
				 * in the editor correctly
				 */
				let siteID = this.props.attributes.siteID;

				if( siteID ) {
					this.processGetBlocksRequest( siteID )
						.catch( error => console.log( error ) );
				}
			}

			/**
			 * Run this when wanting to update any attributes, pass it an object for setAttributes();
			 * https://developer.wordpress.org/block-editor/developers/block-api/block-attributes/
			 * @param attributes
			 */
			updateAttributes( attributes ) {
				this.props.setAttributes(attributes);
			}

			/**
			 * returns the site object from the SareData array by ID
			 * @param id
			 * @returns {*}
			 */
			getSiteByID( id ) {
				return SareData.sites.find( site => {
					return Number(site.blog_id) === id
				});
			}

			getBlockByID( id ) {
				return this.state.siteBlocks.find( block => {
					return Number( block.ID ) === id;
				});
			} 

			/**
			 * Returns jsx to render options inside the select.
			 * @returns {*}
			 */
			renderSiteOptions() {
				let sites = SareData.sites;
				return sites.map((site) =>
					<option value={site.blog_id} key={site.blog_id}>{site.siteName}</option>
				);
			}

			/**
			 * Returns the post_content as html from the chosen block for use in the render preview.
			 * If no block is chosen, returns a message saying so.
			 * @returns {string}
			 */
			renderBlockPreview() {
				let blockID = this.props.attributes.blockID;

				if( ! blockID ) {
					return 'Please choose a block to see its preview';
				}

				let block = this.getBlockByID( blockID );

				if( block ) {
					return block.rendered_content;
				}

				return 'Sorry, the selected block is not available';
			}

			/**
			 *
			 * @param siteID
			 * @returns {Promise<T>}
			 */
			processGetBlocksRequest( siteID ) {
				return this.getBlocks( siteID )
					.then( this.handleGetBlocksResponse );
			}

			/**
			 * Gets the shared blocks associated with the given site ID
			 * @param selectedSiteId
			 * @returns {Promise<T>}
			 */
			getBlocks( selectedSiteId ) {
				// let siteUrl = SareData.currentSiteUrl;
				return apiFetch({ path: `/sare/v1/shared-blocks/site/${selectedSiteId}` } );
			}

			/**
			 * Handles the REST response after fetching blocks for a site
			 * @param {array} blocks
			 */
			handleGetBlocksResponse( blocks ) {
				this.setState({ siteBlocks: blocks });
			}

			/**
			 * Format the blocks to populate the select menu.
			 * @returns {string|array}
			 */
			renderBlocksOptions() {
				let blocks = this.state.siteBlocks;

				if( blocks.length  ) {
					return blocks.map((block) =>
						<option value={block.ID} key={block.ID}>{block.post_title}</option>
					);
				}
				return(
					<option>No Blocks</option>
				);
			}

			handleBlockSelectChange(event) {
				let blockID = Number( event.target.value ) || 0;
				this.setState({newRender: true});
				this.updateAttributes( { blockID : blockID } );
			}

			/**
			 * Handles what happens when user switches the site select in the block.
			 * @param event
			 */
			handleSiteSelectChange(event) {
				let siteID = Number( event.target.value ) || 0;
				this.updateAttributes( { siteID: Number(siteID), blockID: 0 } );
				this.processGetBlocksRequest(siteID);
			}

			/**
			 * Handles the selected tab on tab select.
			 * Link to fantastic documentation: https://developer.wordpress.org/block-editor/components/tab-panel/
			 * runs updating attributes, then gets the attributes to show / hide the 'new' badge
			 * @param tabName
			 */
			handleOnSelectTab( tabName ) {
				Promise.all([this.setState({ selectedTab: tabName })]).then(() => {
					if(this.state.selectedTab === 'rendered') {
						this.setState( { newRender: false } );
					}
				});
			}

			/**
			 * Sends the markup to the tab based on what is selected
			 * @returns {null|*}
			 */
			getTabBodyMarkup() {
				switch (this.state.selectedTab) {
					case 'select' :
						return (
							<div className="controls">
								<select value={this.props.attributes.siteID} onChange={ this.handleSiteSelectChange.bind(this) }>
									<option value={0}>Choose Site...</option>
									{this.renderSiteOptions()}
								</select>
								{this.state.siteBlocks ?
									<select value={this.props.attributes.blockID} onChange={ this.handleBlockSelectChange.bind(this) }>
										<option value={0}>Choose Block...</option>
										{this.renderBlocksOptions()}
									</select>
									: null
								}
							</div>
						);

					case 'rendered' :
						return(
							<div className="rendered"><div dangerouslySetInnerHTML={ { __html: this.renderBlockPreview() } } /></div>
						);
				}
				return null;
			}

			/**
			 *
			 * @returns {*}
			 */
			render() {
				return(
					<div className="sare-block sare-block-network-shared">
						<TabPanel className="preview-tab-panel"
								  activeClass="active-tab"
								  onSelect={ this.handleOnSelectTab.bind(this) }
								  initialTabName={ this.state.selectedTab }
								  tabs={ [
									  {
										  name: 'select',
										  title: 'Select Block',
										  className: 'select-tab',
									  },
									  {
										  name: 'rendered',
										  title: 'Preview',
										  className: this.state.newRender ? 'rendered-tab new' : 'rendered-tab',
									  },
								  ] }>
							{
								( ) => this.getTabBodyMarkup(  )
							}
						</TabPanel>					</div>
				);
			}
		},

		/**
		 * We save nothing to the database as we render dynamic content in PHP class::render()
		 *
		 * @returns {null}
		 */
		save: () => {
			return null;
		}

	});
